const trips = {
  statuses: {
    new: 'Wartende Flotte',
    approved: 'Akzeptiert',
    canceled: 'Abgelehnt',
  },
  table: {
    floatingActions: {
      tooltips: {
        accept: 'This action is only available for trips with  ‘Awaiting Fleet’ status.',
        decline: 'This action is only available for trips with  ‘Awaiting Fleet’ status.',
      },
    },
    filters: {
      supplier: 'Flotten',
    },
    statuses: {
      new: 'Wartende Flotte',
      approved: 'Akzeptiert',
      canceled: 'Abgelehnt',
    },
    headers: {
      supplier: 'Flotte',
    },
    cells: {
      supplier: {
        none: 'Keine Flotte',
      },
      actions: {
        approve: 'Akzeptieren',
        remove: 'Ablehnen',
      },
    },
  },
};

export default trips;
